function adjustEmptyCartWidth() {
  
  const csCartItemsContainer = document.querySelector('.cart-items')
  const csCartItemsParent = csCartItemsContainer.closest('.shopify-section')
  // console.log(csCartItemsContainer);
  
  if (csCartItemsContainer.classList.contains('is-empty')) {
    csCartItemsParent.style.width = '100%';
  } else {
    if (csCartItemsParent) {
      csCartItemsParent.style.width = '60%';
    }
  }

}

document.addEventListener('DOMContentLoaded', function() {
  adjustEmptyCartWidth()
})

function discountOnCheckout() {       
    setTimeout(function(){      
        const csCheckoutButton = document.getElementById('cs-checkout')
        const csCartForm = document.getElementById('CartDrawer-Form')

        if (csCheckoutButton) {
          csCheckoutButton.addEventListener('click', function(e) {
              e.preventDefault()
              var discountCode = 'FREESHIPPING';
              var redirectUrl = '/checkout';
              csCartForm.submit()
              window.location.href = '/discount/' + discountCode + '?redirect=' + encodeURIComponent(redirectUrl);
              // console.log('checkout clicked')
          })
        }
    }, 100)
}

discountOnCheckout()

class CartWatcher {

    init() {
      this.emitCartChanges().then(() => {
        this.observeCartChanges();
      });
    }
  
    async fetchCart() {
      const response = await fetch('/cart.js');
      return response.json();
    }
  
    storeCart(cart) {
      localStorage.setItem('cart', JSON.stringify(cart));
    }
  
   storedCart() {
      return JSON.parse(localStorage.getItem('cart')) || { items: [] };
    }
  
   findCartChanges(oldCart, newCart) {
      const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
      let result = {
        added: onlyInLeft(newCart.items, oldCart.items),
        removed: onlyInLeft(oldCart.items, newCart.items),
      };
  
      oldCart.items.forEach(oi => {
        const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
        if (!ni) return;
        let quantity = ni.quantity - oi.quantity;
        let item = { ...ni };
        item.quantity = Math.abs(quantity);
        quantity > 0
          ? result.added.push(item)
          : result.removed.push(item)
      });
  
      return result;
    }
  
    async emitCartChanges() {
      const newCart = await this.fetchCart();
      const oldCart = this.storedCart();
      const changes = this.findCartChanges(oldCart, newCart);
  
      const event = new CustomEvent("cart_changed", { detail: changes });
      window.dispatchEvent(event);
  
      this.storeCart(newCart);
    }
  
   observeCartChanges() {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            this.emitCartChanges();
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    }
  }

const myCartWatcher = new CartWatcher;
myCartWatcher.init();
window.addEventListener("cart_changed", e => {
    // console.log(e.detail)
    discountOnCheckout()
    adjustEmptyCartWidth()
});

// jquery preload

$(function(){

  var windowWidth = $(window).width()

  function csDropdown() {
    if (windowWidth <= 750) {
      $('.cs-dropdown').each(function() {
        $(this).on('click', function() {
          var thisDropdown = $(this)
          var nextUl = $(this).next('ul')   
          if (thisDropdown.hasClass('active')) {
            nextUl.slideUp(100)
            thisDropdown.removeClass('active')
          } else {
            nextUl.slideDown(100)
            thisDropdown.addClass('active')
          }
        })
      })
    }
  }

  csDropdown()

  // custom dropown
  
    // Check the window width on window resize
    $(window).resize(function() {
      windowWidth = $(window).width()
      // Perform specific actions if the width is less than or equal to 748px
      if (windowWidth <= 748) {
        csDropdown()
      }
    })
  })
/* Bottom mobile nav — rebind Shop / Reviews / Cart.
   The section's own script dies on a missing Swiper before it binds these. */
;(function () {
  if (window.__camBottomNavFix) return;
  window.__camBottomNavFix = true;

  function openPanel(which) {
    var drawer     = document.querySelector('.drawer');
    var shopList   = document.querySelector('div.shop-list');
    var reviewList = document.querySelector('div.review-list');

    if (which === 'cart') {
      reviewList && reviewList.classList.remove('open');
      shopList   && shopList.classList.remove('open');
      drawer     && drawer.classList.add('animate', 'active');
    } else if (which === 'shop') {
      drawer     && drawer.classList.remove('animate', 'active');
      reviewList && reviewList.classList.remove('open');
      shopList   && shopList.classList.add('open');
    } else if (which === 'reviews') {
      drawer     && drawer.classList.remove('animate', 'active');
      shopList   && shopList.classList.remove('open');
      reviewList && reviewList.classList.add('open');
    }
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest('.bottom-nav-item');
    if (item) {
      if (item.classList.contains('cart'))    { e.preventDefault(); openPanel('cart');    return; }
      if (item.classList.contains('shop'))    { e.preventDefault(); openPanel('shop');    return; }
      if (item.classList.contains('reviews')) { e.preventDefault(); openPanel('reviews'); return; }
    }
    var close = e.target.closest && e.target.closest('.bottom-nav-close');
    if (close && close.parentElement) close.parentElement.classList.remove('open');
  });
})();
  